// extracted by css-extract-rspack-plugin
export default {"wrap":"wrap-oSS_DQ","grid":"grid-ABYEc4"};